import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

interface SuccessRateChartProps {
  success: number;
  failure: number;
}

export const SuccessRateChart: React.FC<SuccessRateChartProps> = ({ success, failure }) => {
  const data = [
    { name: "Success", value: success },
    { name: "Failure", value: failure },
  ];
  const colors = ["#10b981", "#ef4444"];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h3 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">Success Rate</h3>
      <div className="min-h-[240px]">
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={90}
              paddingAngle={4}
              dataKey="value"
              stroke="none"
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "0.75rem",
              }}
              itemStyle={{ color: "#0f172a" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
